<template>
    <div class="main orange noTakeaway">
        <Banner :banner="banner"/>

        <div class="text">
            <p>针对在零售电商上市公司财报，网经社<a href="https://www.100ec.cn/" target="_blank">（100EC.CN）</a>每季度都会根据财报发布<a href="http://www.100ec.cn/zt/dskp/">快评</a>、<a href="http://www.100ec.cn/zt/tjcb/">图解财报</a>、<a href="http://www.100ec.cn/zt/cwfx/">财务分析</a>及数据报告等进行持续跟踪。</p>
            <p><b>零售电商定义：</b>狭义指通过网络渠道进行商品交易活动，包括实物商品交易及虚拟商品交易。广义上网经社将零售电商定义为一种业态，包含平台、商家、品牌、用户、服务商等。按模式分，有C2C、B2C、C2M、B2B2C等；按品类分，有综合电商、垂直电商；按交易市场分，有进口跨境电商、出口跨境电商；新电商有会员制电商、直播电商、精品电商、小程序电商等。</p>
        </div>

        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                
                <!-- <Text :text="text"/> -->
                <Article :article="review1"/>
                <Article :article="review2"/>
                <Article :article="review3"/>
                <Article :article="review4"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'q2lsds',
    // meta配置
    metaInfo: {
        title: '【专题】' + '2021年Q2零售电商上市公司财报解读',
        meta: [
            {
                name: 'keywords',
                content: '财报解读 阿里巴巴财报 唯品会财报 微盟财报 万物新生财报'
            },
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/q2lsds/banner.jpg'),
                title: [
                    '2021年Q2零售电商上市公司财报解读',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '【图解财报】阿里巴巴2021年Q2： 营收不及预期 仅为2057.4亿元',
                    url: '/detail--6598892.html'
                },
                {
                    title: '【图解财报】唯品会2021年Q2： 持续盈利 营收达296亿元',
                    url: '/detail--6599571.html'
                },
                {
                    title: '【图解财报】微盟2021上半年财报：营收13.83亿元 同比增长44.5%',
                    url: '/detail--6599421.html'
                },
                {
                    title: '【图解财报】万物新生2021年二季报：营收增长超五成 亏损同比扩大',
                    url: '/detail--6599545.html'
                },
            ],

            // 头部电商
            review1: {
                title: {
                    topic: '头部电商',
                },
                nav: [
                    {
                        value: '阿里 财报',
                        label: '阿里'
                    },
                    {
                        value: '京东 财报',
                        label: '京东'
                    },
                    {
                        value: '拼多多 财报',
                        label: '拼多多'
                    },
                ],
                params: {
                    p: 1,
                    n: 4,
                    terms: '阿里'
                },
            },

            // 准一线电商
            review2: {
                title: {
                    topic: '准一线电商',
                },
                nav: [
                    {
                        value: '唯品会 财报',
                        label: '唯品会'
                    },
                    {
                        value: '小米 财报',
                        label: '小米'
                    },
                    {
                        value: '苏宁易购 财报',
                        label: '苏宁易购'
                    },
                ],
                params: {
                    p: 1,
                    n: 4,
                    terms: '唯品会'
                },
            },

            // 电商服务商
            review3: {
                title: {
                    topic: '电商服务商',
                },
                nav: [
                    {
                        value: '宝尊电商 财报',
                        label: '宝尊电商'
                    },
                    {
                        value: '有赞 财报',
                        label: '有赞'
                    },
                    {
                        value: '微盟 财报',
                        label: '微盟'
                    },
                ],
                params: {
                    p: 1,
                    n: 4,
                    terms: '宝尊电商'
                },
            },

            // 其他
            review4: {
                title: {
                    topic: '其他',
                },
                nav: [
                    {
                        value: '快手 财报',
                        label: '快手'
                    },
                    {
                        value: '万物新生 财报',
                        label: '万物新生'
                    },
                    {
                        value: 'B站 财报',
                        label: 'B站'
                    },
                ],
                params: {
                    p: 1,
                    n: 4,
                    terms: '快手'
                },
            },
        }
    },
}
</script>

<style>
    .text {
        max-width: 1100px;
        margin: auto;
        padding: 0 10px;
        box-sizing: border-box;
        border: 2px solid #AD0260;
    }
    .text p {
        line-height: 35px;
        font-size: 20px;
        text-indent: 2em;
        font-size: 20px;
        word-wrap: break-word;
}

    @media (max-width: 1100px) {
        .text p {
            line-height: 2;
            text-indent: 2em;
            font-size: 14px;
            word-wrap: break-word;
        }
    }
</style>
